export default {
  name: 'id',
  data: {
    modal: {
      cancel: 'Batal',
      confirm: 'Ya'
    },
    pagination: {
      prev: 'Sebelumnya',
      next: 'Berikutnya'
    },
    select: {
      empty: 'Tidak Ada Data... \\[ o_x ]/'
    },
    table: {
      empty: 'Tidak Ada Data... \\[ o_x ]/'
    }
  }
}